import React from 'react'
import styled from 'styled-components'

const Row = ({
  id = '',
  mwidth = '100%',
  width = '100%',
  minh = '0',
  flex = 'nowrap',
  pad = '0',
  mpad = '0',
  justify = 'space-between',
  align = 'center',
  gap = '20px',
  mgap = gap,
  bg = 'none',
  scroll = 'visible',
  staticEnd = false,
  children,
}) => {
  return (
    <Wrap
      $id={id}
      $mwidth={mwidth}
      $width={width}
      $minh={minh}
      $flex={flex}
      $pad={pad}
      $mpad={mpad}
      $justify={justify}
      $align={align}
      $bg={bg}
      $scroll={scroll}
      $gap={gap}
      $mgap={mgap}
      $staticEnd={staticEnd}

    >
      {children}
    </Wrap>
  )
}

export default Row

const Wrap = styled.div`
  width: ${(props) => props.$mwidth};
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${(props) => props.$mgap};
  justify-content: ${(props) => props.$justify};
  align-items: ${(props) => props.$align};
  background: ${(props) => props.$bg};
  overflow-x: ${(props) => props.$scroll};
  padding: ${(props) => props.$pad};
  flex-wrap: ${(props) => props.$flex};
  min-height: ${(props) => props.$minh};
  padding: ${(props) => props.$pad};
    position: ${(props) => (props.$staticEnd ? "fixed" : "static")};            
    bottom: ${(props) => (props.$staticEnd ? "0px" : "unset")};            
 
  @media (width > 800px) {
    width: ${(props) => props.$width};
    padding: ${(props) => props.$pad};
    row-gap: ${(props) => props.$gap};
    position: ${(props) => (props.$staticEnd ? "unset" : "unset")};            
    bottom: ${(props) => (props.$staticEnd ? "unset" : "unset")};            
 
    /* background: ${(props) => (props.$staticEnd ? "unset" : "unset")};   */

  }
`
